import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {Provider} from "react-redux";
import {BrowserRouter as Router} from "react-router-dom";
import {configureStore} from '@reduxjs/toolkit';
import authstateReducer from "./slices/auth";
import profileReducer from "./slices/profile";
import dialogReducer from "./slices/dialog";
import alertReducer from "./slices/alert";
import selectedReducer from "./slices/selected";
import managementReducer from "./slices/management";
import loadingReducer from "./slices/loading";
import videoReducer from "./slices/video";
import {ThemeProvider} from "@material-ui/core";
import {createTheme} from '@material-ui/core/styles';
import "./languages/i18n";

const reducers = {
    authstate: authstateReducer,
    profile: profileReducer,
    dialog: dialogReducer,
    alert: alertReducer,
    selected: selectedReducer,
    management: managementReducer,
    loading: loadingReducer,
    video: videoReducer,
};

// const persistConfig = {
// 	key: "root",
// 	storage,
// };
// const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({serializableCheck: false}),
});

const theme = createTheme({
    typography: {
        fontFamily: ['Poppins'],
        htmlFontSize: 10,
    },
    palette: {
        primary: {
            main: '#0059AA',
        },
        secondary: {
            main: '#FF8B00',
        },
    }
});

ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <Router>
                <ThemeProvider theme={theme}>
                    <App/>
                </ThemeProvider>
            </Router>
        </React.StrictMode>
    </Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
